export default __webpack_public_path__ + "static/media/Icon-Live-Safer.960bd5f7.svg";